import type { ReactGridLayoutProps } from 'react-grid-layout';

/** Configuration options used to customize react-grid-layout. */
export const panelGridLayoutConfig: Required<
  Pick<
    ReactGridLayoutProps,
    'margin' | 'containerPadding' | 'cols' | 'rowHeight' | 'draggableHandle'
  >
> = {
  margin: [12, 12],
  containerPadding: [0, 0],
  cols: 24,
  rowHeight: 40,
  draggableHandle: 'panelDragHandle',
};
